import React from 'react';
import PropTypes from 'prop-types';
import compose from '../hoc/compose';
import displayNames from './displayNames';
import Button from './button.js';
import { default as HeaderBackButtonSymbol } from 'wix-ui-icons-common/classic-editor/system/ChevronLeft';

var HeaderBackButton = function HeaderBackButton(_ref) {
  var automationId = _ref.automationId,
      dataHook = _ref.dataHook,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Button, {
    automationId: automationId,
    dataHook: dataHook,
    className: "btn-header-back btn-header btn-back",
    onClick: onClick
  }, /*#__PURE__*/React.createElement(HeaderBackButtonSymbol, null));
};

HeaderBackButton.displayName = displayNames.HEADER_BACK_BUTTON;
HeaderBackButton.propTypes = {
  onClick: PropTypes.func
};
export default compose(HeaderBackButton);